/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/trailer_medium'
export default icon
